export const allKeyCodes = {
    ArrowRight: 'ArrowRight',
    ArrowLeft: 'ArrowLeft',
    a: 'a',
    d: 'd'
};

// Все события, которые тут прописаны, должны быть описаны в gameController
export const keydownKeyCodes = {
    ArrowRight: allKeyCodes.ArrowRight,
    ArrowLeft: allKeyCodes.ArrowLeft,
    a: allKeyCodes.a,
    d: allKeyCodes.d
};

export const keyupKeyCodes = {
    ArrowRight: allKeyCodes.ArrowRight,
    ArrowLeft: allKeyCodes.ArrowLeft,
    a: allKeyCodes.a,
    d: allKeyCodes.d
};
